import React from 'react';

import CheckNew from 'crehana-icons/CheckNew';
import { secondaryLight } from 'crehana-ui/styles/colors';

import StringParser from 'Jsx/Shared/StringParser';

const BulletCheck = ({
  paragraph,
  iconColor = secondaryLight,
  iconSize = 16,
}: {
  paragraph: string;
  iconColor?: string;
  iconSize?: number;
}) => (
  <li className="mb-12 flex items-baseline">
    <span className="mr-8 inline-block">
      <CheckNew size={iconSize} color={iconColor} />
    </span>
    <span className="font-body2 inline-block">
      <StringParser string={paragraph} breaks style link>
        {({ string }) => string}
      </StringParser>
    </span>
  </li>
);

export default BulletCheck;
